export default __webpack_public_path__ + "static/media/image-12.5fe40f37.png";